import { StatusDot } from "./StatusDot";

export const StatusComponent = ({ data }) => {
  const stage = data?.stage;
  const joined = data?.joined;

  if (stage == "0") {
    return <span style={{color:"red"}}>Scheduled</span>;
  }

  if (stage == "1") {
    return (
      <div>
        <StatusDot color={joined == "1" ? "#4caf50" : "red"} />
        {/* <StatusDot color={joined == "1" ? "#4caf50" : "red"} /> */}
        <span style={{color:"red" , marginLeft:"10px"}}>Meeting Started</span>
      </div>
    );
  }

  return null;
};